export const DIARY_PERMISSIONS = {
  // Principal / coordinators: see every teacher's diary and approve it.
  // Keep in sync with the "Weekly Diary" item in containers/_nav.js.
  VIEW: "weekly_diary.view",
  // Reviewers (principal / coordinators) see every teacher's diary, tag lessons and approve.
  // Without it the page shows the teacher's own diaries (no Teacher Name column, read-only).
  REVIEW: "lesson_plan.view_all",
};

// "Weekly Update": has the teacher sent the diary for the week?
export const WEEKLY_UPDATE_STATUS = {
  in_progress: { label: "In Progress", tone: "secondary" },
  sent: { label: "Sent", tone: "success" },
};

// "Principal's Approval" (empty until the diary is sent)
export const APPROVAL_STATUS = {
  approved: { label: "Approved", tone: "success" },
  pending: { label: "Pending", tone: "warning" },
  needs_attention: { label: "Needs Attention", tone: "danger" },
};

// For the shared Select ({ id, name }); its empty first option is "All"
export const DIARY_STATUS_FILTER_OPTIONS = [
  { id: "approved", name: "Approved" },
  { id: "pending", name: "Pending" },
  { id: "not_submitted", name: "Not Submitted" },
];

export const REVIEW_TAGS = {
  follow_up: { label: "Follow - Up", tone: "warning" },
  needs_attention: { label: "Needs Attention", tone: "danger" },
};

export const EXECUTION_FILTER_OPTIONS = [
  { id: "completed", name: "Completed" },
  { id: "pending", name: "Pending" },
  { id: "flagged", name: "Flagged" },
];

export const SEARCH_DEBOUNCE_MS = 400;
